var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2093_1928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83105 0.720387C4.60547 0.175465 4.01074 -0.114574 3.44238 0.0406996L0.864258 0.743825C0.354492 0.88445 0 1.34734 0 1.87468C0 9.12273 5.87695 14.9997 13.125 14.9997C13.6523 14.9997 14.1152 14.6452 14.2559 14.1354L14.959 11.5573C15.1143 10.9889 14.8242 10.3942 14.2793 10.1686L11.4668 8.99675C10.9893 8.79754 10.4355 8.93523 10.1104 9.3366L8.92676 10.7809C6.86426 9.80535 5.19434 8.13543 4.21875 6.07293L5.66309 4.89226C6.06445 4.56414 6.20215 4.01336 6.00293 3.53582L4.83105 0.723317V0.720387Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2093_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSolidIcon);
export default __webpack_public_path__ + "static/media/phone-solid-icon.debb6d14285949108c13deb54a06efa9.svg";
export { ForwardRef as ReactComponent };